<!-- Side Structure -->
<template>
  <div class="sidebar sidebar-overlay-dark">
    <v-layout pl-3 pb-4 style="padding-top:36px">
      <v-flex xs12>
        <h3>{{ $t('message.sidebarTitle') }}</h3>
      </v-flex>
    </v-layout>
    <v-layout mt-1 mb-4 row wrap
      style="clip-path: polygon(0 10%, 0 90%, 100% 51%);background-image: linear-gradient(to right, #1f98f3, #011e41);height:10px">
    </v-layout>
    <div style="text-align:center">
      <v-icon color="blue" @click="endMenu" dark medium>arrow_downward</v-icon>
    </div>
    <vue-perfect-scrollbar class="scroll-area" style="height:calc(100vh - 270px)" :settings="settings">
      <v-toolbar flat class="transparent scroll-area navigation">
        <v-list>
          <div ref="startMenuScrollIntoView" />
          <template v-for="(category, key) in menus">
            <div :key="key">
              <div class="sidebar-title px-3">
                <!--  <span>{{$t(key)}}</span> -->
              </div>
              <template v-for="item in category">
                <template v-if="item.items != null">
                  <v-list-group :key="item.title" prepend-icon="arrow_right" append-icon no-action v-model="item.active"
                    v-if="item.ap">
                    <v-list-tile slot="activator">
                      <v-list-tile-content>
                        <v-list-tile-title :title="$t(item.title)">
                          <i class="mr- zmdi" :class="item.action"></i>
                          <span>{{ textTruncate($t(item.title)) }}</span>
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-for="subItem in item.items" v-bind:key="subItem.title"
                      :to="!subItem.exact ? `/${getCurrentAppLayoutHandler() + subItem.path}` : subItem.path">
                      <v-list-tile-content>
                        <v-list-tile-title :title="$t(subItem.title)">{{ textTruncate($t(subItem.title)) }} 
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list-group>
                </template>
                <template v-else>
                  <v-list-tile v-if="checkPermisions(item.permisions,item.admin, item.domains) && chechCifraseg(item) && checkApsFilter(item) &&   (allowBonusCategory ? item.title !== '' : item.title !== 'message.bonusCategory')"
                    :to="!item.exact ? `/${getCurrentAppLayoutHandler() + item.path}` : item.path" :key="item.path">
                    <v-list-tile-content class="ml-4">
                      <v-list-tile-title :title="$t(item.title)">
                        <i class="zmdi" :class="item.action"></i>
                        <span>{{ textTruncate($t(item.title)) }}</span>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </template>
            </div>
          </template>
          <div ref="endMenuScrollIntoView" />
        </v-list>
      </v-toolbar>
    </vue-perfect-scrollbar>
    <div style="text-align:center">
      <v-icon color="blue" @click="startMenu" dark medium>arrow_upward</v-icon>
    </div>
    <app-logo style="position:absolute;bottom:40px;left:10%"></app-logo>
  </div>
</template>
<script>

import { textTruncate, getCurrentAppLayout, log, getDomainFromEmail } from "@/common/helpers/helpers";
import { mapGetters } from "vuex";
import AppLogo from "@/components/AppLogo/AppLogo";
import serviceFactura from '@/services/FacturaServices';
import AppConfig from "@/config/AppConfig";

export default {
  data() {
    return {
      settings: {
        maxScrollbarLength: 160
      },
      filtrarAps: false,
      apsIds: [],
      allowBonusCategory: false 
    };
  },
  components:
  {
    AppLogo
  },
  computed: {
    ...mapGetters(["menus", "userProfile", "userScopes","agency_id"]),
    isCommissionRoute() {
      // SIN optional chaining para evitar el warning
      const path = (this.$route && this.$route.path ? this.$route.path : '').toLowerCase();
      return path.indexOf('/commission') !== -1;   // true si es ruta de comisiones
    },
     isProductionRoute() {
      // SIN optional chaining para evitar el warning
      const path = (this.$route && this.$route.path ? this.$route.path : '').toLowerCase();
      return path.indexOf('/bonusProduction') !== -1;   // true si es ruta de comisiones
    },
    isCategoryRoute() {
      // SIN optional chaining para evitar el warning
      const path = (this.$route && this.$route.path ? this.$route.path : '').toLowerCase();
      return path.indexOf('/bonusCategory') !== -1;   // true si es ruta de comisiones
    },
    isComplianceRoute() {
      // SIN optional chaining para evitar el warning
      const path = (this.$route && this.$route.path ? this.$route.path : '').toLowerCase();
      return path.indexOf('/bonusCompliance') !== -1;   // true si es ruta de comisiones
    }
  },
  watch: {
    '$route.fullPath'() {
      this.syncValidaSucursalFromRoute();
    }
  
},
  mounted() {
    this.loadFiltroAps();
    this.fetchApsCategory();
            console.log("mounted called");
        console.log(this.$global.validaSucursal);
    this.syncValidaSucursalFromRoute();

     
  },
  methods:
  {
    
      syncValidaSucursalFromRoute() {

    const isCommission = this.isCommissionRoute; 
    const isProduction = this.isProductionRoute; 
    const isCategory = this.isCategoryRoute; 
     const isCompliance = this.isComplianceRoute; 

    // En comisiones: solo poner false si NO está en true manualmente
    if (isCommission) {
      if (this.$global.validaSucursal !== true) {
        this.$global.validaSucursal = false;
      }
    }

     if (isProduction) {
      if (this.$global.validaSucursal !== true) {
        this.$global.validaSucursal = false;
      }
    }
     if (isCategory) {
      if (this.$global.validaSucursal !== true) {
        this.$global.validaSucursal = false;
      }
    }
     if (isCompliance) {
        if (this.$global.validaSucursal !== true) {
          this.$global.validaSucursal = false;
        }
      }
    // Fuera de comisiones: no toques la global
  },
    
    checkApsFilter(item) {

      // Si no se debe filtrar, se muestra todo
      if (!this.filtrarAps) return true;

      // Si el ítem no tiene la bandera `validateKerygMaseg`, se muestra también
      if (!item.validateKerygMaseg) return true;

      // Si tiene la bandera, solo se muestra si el agency_id está en la lista
      var result = this.apsIds.includes(this.userProfile.id_aps_vt);


      return  result;
    }
    ,
    async fetchApsCategory() {
    try {
      const res = await serviceFactura.ValidacionCategoriaMenu(this.userProfile.id_aps_vt);
      this.allowBonusCategory = res.data.Data;
    } catch (e) {
      console.error('Error ValidacionCategoriaMenu:', e);
      this.allowBonusCategory = false;
    }
  },
    async loadFiltroAps() {
      try {
        
        const res = await serviceFactura.ValidacionMenu();
        this.filtrarAps = res.data.Data.FiltrarAps;
        this.apsIds = res.data.Data.ApsId;
      } catch (error) {
        console.error("Error al cargar filtros APS:", error);
      }
    },
    startTour() {
      this.$tours["myTour"].start();
    },
    textTruncate(text) {
      return textTruncate(text, 25);
    },
    getCurrentAppLayoutHandler() {
      return getCurrentAppLayout(this.$router);
    },
    startMenu() {
      this.$refs.startMenuScrollIntoView.scrollIntoView();
    },
    endMenu() {
      this.$refs.endMenuScrollIntoView.scrollIntoView();
    },
    chechCifraseg(item) {
      if (item.cifraseg && this.userProfile.user_id != 1016) {
        return false;
      } else {
        return true;
      }
    },
    checkPermisions(permisionList, admin, domainList) {
      let hasPermission = false;
      const userType = this.userScopes;

      //59772_T
      // if(item.validateKerygMaseg /* && permisionList.length == 0 */){
      //       if(this.userProfile.user_id === AppConfig.BrokerKerygmaseg 
      //       || (this.userProfile.aps != undefined  && this.userProfile.aps === AppConfig.BrokerKerygmaseg)){
      //           hasPermission = true;
      //           return hasPermission;
      //       }
      // }

      if (this.userScopes.includes("aps_admin") && !admin) {
        hasPermission = false;
      } else {
        hasPermission = userType.some(r => permisionList.indexOf(r) >= 0)
      }
      if (domainList) {
        let email = this.userProfile.email;
        let emailDomain = '@' + getDomainFromEmail(email);
        //log("emailDomain:", emailDomain);
        let hasDomain = domainList.includes(emailDomain);
        return hasPermission && hasDomain;
      }
      return hasPermission;
    }
  }
};
</script>
<style>
.ps:hover>.ps__scrollbar-y-rail:hover {
  background-color: transparent;
  opacity: 0.9;
}

.ps.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail {
  background-color: transparent !important;
  opacity: 0.9;
}
</style>